import logoEn from "../img/icons/en.jpg";
import logoKa from "../img/icons/ka.png";

const firstMenu = {
    en: [
        {
            id: "products",
            path: "/products",
            name: "Products",
        },
        {
            id: "captain",
            path: "/captain-story",
            name: "The Captain’s story",
        },
    ],
    ka: [
        {
            id: "products",
            path: "/products",
            name: "პროდუქცია",
        },
        {
            id: "captain",
            path: "/captain-story",
            name: "კაპიტნის ამბავი",
        },
    ],
};

const secondMenu = {
    en: [
        {
            id: "about",
            path: "/about",
            name: "About us",
        },
        {
            id: "stores",
            path: "/stores",
            name: "Stores",
        },
    ],
    ka: [
        {
            id: "about",
            path: "/about",
            name: "ჩვენ შესახებ",
        },
        {
            id: "stores",
            path: "/stores",
            name: "მაღაზიები",
        },
    ],
};

const footerMenu = {
    en: [
        {
            id: "career",
            path: "/career",
            name: "Career",
        },
        {
            id: "faq",
            path: "/faq",
            name: "FAQ",
        },
        // {
        //     id: "franchising",
        //     path: "/franchising",
        //     name: "Franchising",
        // },
        {
            id: "contact",
            path: "/contact",
            name: "Contact",
        },
    ],
    ka: [
        {
            id: "career",
            path: "/career",
            name: "კარიერა",
        },
        {
            id: "faq",
            path: "/faq",
            name: "ხ.დ.კ.",
        },
        // {
        //     id: "franchising",
        //     path: "/franchising",
        //     name: "ფრანჩაიზინგი",
        // },
        {
            id: "contact",
            path: "/contact",
            name: "კონტაქტი",
        },
    ],
};

const language = {
    en: {
        code: "ka",
        name: "ქართული",
        img: logoKa,
    },
    ka: {
        code: "en",
        name: "English",
        img: logoEn,
    },
};


export {
    firstMenu,
    secondMenu,
    language,
    footerMenu,
};